import * as React from 'react'

import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import type Policy from 'modules/payroll_bundle/store/models/Policy'

import hideCountrySelector from '../helpers/hideCountrySelector'

const SHOW_COUNTRY = 'SHOW_COUNTRY'

const SHOW_BOOKKEEPER = 'SHOW_BOOKKEEPER'

const SHOW_PAYROLL_POLICY = 'SHOW_PAYROLL_POLICY'

interface Props {
  policy?: Policy | null
}

const useSetStage = ({ policy }: Props) => {
  const hideCountryStage = hideCountrySelector()
  const showPolicyStage = !contractVersionsPayrollPolicies.find({
    payroll_policy_id: policy?.attributes.id,
  })
  const secondStage = showPolicyStage ? SHOW_PAYROLL_POLICY : SHOW_BOOKKEEPER
  const initialState = hideCountryStage ? secondStage : SHOW_COUNTRY
  const [stage, setStage] = React.useState<string>(initialState)

  return {
    secondStage,
    stage,
    setStage,
  }
}

export default useSetStage
